import { useTheme } from 'lib/context/ThemeContext';
import { IconProps } from '../SvgIcon';

const IconLinkedin = (props: IconProps): JSX.Element => {
  const { themeName } = useTheme();

  return themeName === 'aw' ? (
    <svg
      role="img"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>LinkedIn Icon</title>
      <circle cx="8.20312" cy="8" r="8" fill={props.fillId || 'white'} />
      <path
        d="M11.4115 3.875C11.6546 3.875 11.8877 3.97158 12.0596 4.14349C12.2315 4.31539 12.3281 4.54855 12.3281 4.79167V11.2083C12.3281 11.4514 12.2315 11.6846 12.0596 11.8565C11.8877 12.0284 11.6546 12.125 11.4115 12.125H4.99479C4.75168 12.125 4.51852 12.0284 4.34661 11.8565C4.1747 11.6846 4.07812 11.4514 4.07812 11.2083V4.79167C4.07812 4.54855 4.1747 4.31539 4.34661 4.14349C4.51852 3.97158 4.75168 3.875 4.99479 3.875H11.4115ZM11.1823 10.9792V8.55C11.1823 8.15372 11.0249 7.77368 10.7447 7.49346C10.4644 7.21325 10.0844 7.05583 9.68813 7.05583C9.29854 7.05583 8.84479 7.29417 8.62479 7.65167V7.14292H7.34604V10.9792H8.62479V8.71958C8.62479 8.36667 8.90896 8.07792 9.26188 8.07792C9.43206 8.07792 9.59527 8.14552 9.7156 8.26586C9.83594 8.38619 9.90354 8.5494 9.90354 8.71958V10.9792H11.1823ZM5.85646 6.42333C6.06068 6.42333 6.25653 6.34221 6.40093 6.19781C6.54533 6.0534 6.62646 5.85755 6.62646 5.65333C6.62646 5.22708 6.28271 4.87875 5.85646 4.87875C5.65103 4.87875 5.45401 4.96036 5.30875 5.10562C5.16348 5.25088 5.08188 5.4479 5.08188 5.65333C5.08188 6.07958 5.43021 6.42333 5.85646 6.42333ZM6.49354 10.9792V7.14292H5.22396V10.9792H6.49354Z"
        fill={props.fillId ? 'white' : 'black'}
      />
    </svg>
  ) : (
    <svg
      role="img"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>LinkedIn Icon</title>
      <circle cx="16" cy="16" r="16" fill={props.fillId || 'white'} />
      <rect x="6" y="6" width="19" height="20" fill={props.fillId ? 'white' : 'black'} />
      <path
        d="M25.3333 4C26.0406 4 26.7189 4.28095 27.219 4.78105C27.719 5.28115 28 5.95942 28 6.66667V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H25.3333ZM24.6667 24.6667V17.6C24.6667 16.4472 24.2087 15.3416 23.3936 14.5264C22.5784 13.7113 21.4728 13.2533 20.32 13.2533C19.1867 13.2533 17.8667 13.9467 17.2267 14.9867V13.5067H13.5067V24.6667H17.2267V18.0933C17.2267 17.0667 18.0533 16.2267 19.08 16.2267C19.5751 16.2267 20.0499 16.4233 20.3999 16.7734C20.75 17.1235 20.9467 17.5983 20.9467 18.0933V24.6667H24.6667ZM9.17333 11.4133C9.76742 11.4133 10.3372 11.1773 10.7573 10.7573C11.1773 10.3372 11.4133 9.76742 11.4133 9.17333C11.4133 7.93333 10.4133 6.92 9.17333 6.92C8.57571 6.92 8.00257 7.1574 7.57999 7.57999C7.1574 8.00257 6.92 8.57571 6.92 9.17333C6.92 10.4133 7.93333 11.4133 9.17333 11.4133ZM11.0267 24.6667V13.5067H7.33333V24.6667H11.0267Z"
        fill={props.fillId || 'white'}
      />
    </svg>
  );
};

export default IconLinkedin;
